import {CellRenderContext, IGridCellRenderer} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import {WSPIcon} from '@mintdata-wsp/resources/icons/WSPIcon';
import {IconCell} from '@mintdata-wsp/wsp/ui/components/grid/cells/IconCell';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./IconCell.less');
const cx = classnames.bind(styles);

export class IconCellRenderer implements IGridCellRenderer
{
    render(ctx:CellRenderContext):React.ReactElement<any>
    {
        const aCell = ctx.cell as IconCell;

        return <span key={ctx.key}
                     style={ctx.style}
                     className={cx('iconCell',
                                   ctx.className)}
                     ref={ctx.ref}>

                        <WSPIcon name={aCell.iconName} size={aCell.iconSize}/>

                </span>;
    }
}
